export const CognitiveAidFormFamily = {
  title: 'Cognitive aid',
  formVersion: 1,
  description: 'Client Cognitive Support Intake Form',
  formKey: 'CLIENT_COGNITIVE_SUPPORT_INTAKE_FORM',
  questions: {
    'CognitiveSupport-challenges': {
      questionId: 'CognitiveSupport-challenges',
      fieldType: 'checkbox',
      rank: 1,
      questionData: {
        label: 'What situations do they find most confusing or challenging?',
        helpText: '',
        required: true,
      },
      options: [
        {value: 'sundowning', label: 'Late afternoon or evening (sundowning)', isOther: false},
        {value: 'new-environments', label: 'New environments or changes in routine', isOther: false},
        {value: 'multi-step', label: 'Following multi-step instructions', isOther: false},
        {value: 'recognizing', label: 'Recognizing people or familiar places', isOther: false},
        {value: 'staying-focused', label: 'Staying focused on daily tasks', isOther: false},
        {value: 'no-challenges', label: 'No major challenges', isOther: false},
        {value: 'other', label: 'Other', isOther: true},
      ],
    },
    'CognitiveSupport-type': {
      questionId: 'CognitiveSupport-type',
      fieldType: 'checkbox',
      rank: 2,
      questionData: {
        label: 'What type of support helps them stay calm and comfortable?',
        helpText: '',
        required: true,
      },
      options: [
        {value: 'gentle-reassurance', label: 'Gentle reassurance', isOther: false},
        {value: 'firm-redirection', label: 'Firm redirection when confused', isOther: false},
        {value: 'steady-routine', label: 'Keeping a steady routine', isOther: false},
        {value: 'one-step', label: 'One-step-at-a-time guidance', isOther: false},
        {value: 'light-conversation', label: 'Light conversation for grounding', isOther: false},
        {value: 'quiet-companionship', label: 'Quiet companionship', isOther: false},
        {value: 'other', label: 'Other', isOther: true},
      ],
    },
    'CognitiveSupport-caregiving-style': {
      questionId: 'CognitiveSupport-caregiving-style',
      fieldType: 'checkbox',
      rank: 3,
      questionData: {
        label: 'What caregiving style works best for them?',
        helpText: '',
        required: true,
      },
      options: [
        {value: 'patient-slow', label: 'Patient and slow-paced', isOther: false},
        {value: 'calm-steady', label: 'Calm and steady presence', isOther: false},
        {value: 'warm-conversational', label: 'Warm and conversational', isOther: false},
        {value: 'clear-simple', label: 'Clear and simple instructions', isOther: false},
        {value: 'space-checkin', label: 'Gives space but checks in often', isOther: false},
        {value: 'structured-routine', label: 'Very structured and routine-oriented', isOther: false},
        {value: 'other', label: 'Other', isOther: true},
      ],
    },
  },
};
